import { z } from 'zod';

// Validate VITE_-prefixed envs at module import time so misconfiguration
// fails the boot rather than surfacing as a runtime undefined deep in feature
// code. Per docs/web/conventions.md §11.1 (env via Zod-validated parseEnv,
// nothing reads import.meta.env outside this module).
//
// VITE_API_BASE_URL points at the EMRA API base URL — defaults to
// http://localhost:3200 in `.env.development` (apps/emra/api uses APP_PORT
// 3200; see apps/emra/README.md).
const schema = z.object({
  VITE_API_BASE_URL: z.string().url(),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`).join('; ');
  throw new Error(`Invalid frontend env: ${issues}`);
}

export const env = parsed.data;
export type Env = typeof env;
